<template>
  <b-container>
    <b-row cols="12">
      <div
        style="z-index: 10"
        class="loading-overlay w-100"
        
        v-if="ngoInfo && ngoInfo.current_stage == 4"
      ></div>
      
      <div
        style="z-index: 10"
        class="loading-overlay"
        v-else-if="ngoInfo==null"
        
      >
        <h3
          style="z-index: 11; position: absolute; top: 40%; right: 21%"
          class=""
        >
          يمكنك الولوج لهذه الصفحة بعد إدخال معلومات المنظمة
        </h3>
      </div>
      <div class="justify-content-between w-100 d-flex align-items-center px-1">
        <h3>الأعضاء المؤسسين</h3>
        <!-- <b-button
          v-if="ngoInfo.status === 'info_evaluating'"
          variant="success"
          @click="newfounderModal = true"
        >
          <feather-icon icon="PlusIcon" />
          إضافة</b-button
        > -->
        <span
            :title="message"
            v-b-tooltip.hover.v-warning.bottom
          >
            <b-button
              variant="success"
              @click="onClickedAddNumber"
              
            >
            <!-- :disabled="isDisabled" -->
              <feather-icon icon="PlusIcon" class="mr-50" />
              إضافة
            </b-button>
          </span>
      </div>
    </b-row>
    <hr />
    <p v-if="founders == null || founders.length == 0"> لا يوجد أعضاء </p>
    <b-table v-else :tbody-tr-class="rowClass" :fields="fields" :items="founders">
        
      <template #cell(inquiry_bulletin_file)="row" >
        <b-button
          size="sm"
          @click="$router.push({ name: 'file-view', query: { ep: row.item.inquiry_bulletin_file } })"
          variant="flat-success"
        >
          <feather-icon class="mx-25" icon="EyeIcon" />
          عرض الملف
        </b-button>
      </template>
      <template #cell(actions)="row">
        <div class="d-flex">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="onUpdateClicked(row.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">تعديل</span>
            </b-dropdown-item>
            <!-- <b-dropdown-item
              :disabled="!row.item.feedback_content"
              @click="
                feedback_content = row.item.feedback_content;
                feedbackModal = true;
              "
            >
              <feather-icon icon="MessageSquareIcon" />
              <span class="align-middle ml-50"> ردود الوزارة</span>
            </b-dropdown-item> -->

            <b-dropdown-item @click="onDeleteFounder(row.item.id)">
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">حذف</span>
            </b-dropdown-item>
          </b-dropdown>
          <!-- <b-button
          size="sm"
          @click="
            feedback_content = row.item.feedback_content;
            feedbackModal = true;
          "
          v-b-tooltip.hover.v-warning.bottom
          title="التعليقات"
          :variant="row.item.feedback_content ? 'warning' : 'outline-warning'"
          class="rounded-circle mx-25 btn-icon"
        >
          <feather-icon size="16" icon="MessageSquareIcon" />
        </b-button> -->
        </div>
      </template>
    </b-table>

    <founders-modal
      @confirm="onUpdateFounder"
      :loading="working"
      :ngoId="ngoInfo.id"
      action="U"
      ref="editFounderModal"
      v-model="editFounderModal"
      :intializeForm.sync="updateFounderForm"
    />
    <founders-modal
      @confirm="onAddFounder"
      :loading="working"
      :ngoId="ngoInfo.id"
      action="C"
      ref="newFounder"
      v-model="newfounderModal"
    />
    <!-- <b-modal
      size="lg"
      v-model="feedbackModal"
      footer-class="removed"
      title="رد الوزارة على معلومات العضو"
    >
      <b-card-text class="p-1">
        <div v-html="feedback_content"></div>
      </b-card-text>
    </b-modal> -->
  </b-container>
</template>

<script>
import { resolveUpdated } from "@/utils/utils";
import {
  BRow,
  BButton,
  BCol,
  BContainer,
  BTable,
  BDropdown,
  BDropdownItem,
  BCardText,
  BModal,
  VBTooltip,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import FoundersModal from "../../components/FoundersModal.vue";
import ToastificationContent from "@/@core/components/toastification/ToastificationContent.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
export default {
  components: {
    BRow,
    BButton,
    BCol,
    BContainer,
    BTable,
    FoundersModal,
    BDropdown,
    BDropdownItem,
    BCardText,
    BModal,
    FeatherIcon,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      editFounderModal: false,
      newfounderModal: false,
      // feedbackModal: false,
      feedback_content: "",
      isDisabled : false ,
      updateFounderForm: {},
      numberOfFounder:null,
      fields: [
        {
          key: "full_name",
          label: "الاسم الثلاثي",
        },
        {
          key: "id_number",
          label: "الرقم الوطني",
        },
        {
          key: "address",
          label: "عنوان السكن",
        },
        {
          key: "qualification.title",
          label: "المؤهل العلمي",
        },
        {
          key: "job.name",
          label: "العمل",
        },
        {
          key: "phone_number",
          label: "رقم الهاتف",
        },
        {
          key: "dob",
          label: "تاريخ الميلاد",
        },
        {
          key: "inquiry_bulletin_file",
          label: "نشرة الإستعلام",
        },
        {
          key: "actions",
          label: "",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("TempNgo", ["founders", , "ngoInfo", "working"]),
    message() {
      if(this.founders == null || Object.keys(this.ngoInfo).length === 0){
        this.isDisabled = true
        return "لا يمكن إضافة الأعضاء قبل إدخال معلومات المنظمة";
      }
      else if(Object.keys(this.ngoInfo).length > 0){
        if(this.ngoInfo.legal_form_type === 'association'){
          this.numberOfFounder = 11
        }
        else  if(this.ngoInfo.legal_form_type === 'institution'){
          this.numberOfFounder = 1
        }
        else{
          this.numberOfFounder = 7
        }
        // if(this.founders.length === numberOfFounder){
        //   this.isDisabled = true
        // }
        return `يجب أن يكون عدد الأعضاء المؤسسين ${this.numberOfFounder} عضو كحد أدنى`
      }
      
      return ``;
    },
  },
  mounted() {
    // this.changeCurrentStage(6)
    document.getElementsByClassName("app-content")[0].classList.add("temp-ngo");
    // console.log('founders' , this.founders);
    // if(!this.founders){
    //   this.founders = [];
    // };
    // console.log('founders' , this.founders);
  },
  
  watch: {
    founders: {
      handler(newVal, oldVal) {
        console.log("this.ngoInfo.current_stage" , this.ngoInfo.current_stage)
        console.log("this.founders.length " , this.founders.length )
        console.log("this.numberOfFounder" , this.numberOfFounder )
        if(this.ngoInfo.current_stage == 1){
          if(this.founders && this.founders.length === this.numberOfFounder ){
            this.changeCurrentStage(2)
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("TempNgo", ["updateFounder", "addFounder", "deleteFounder" , "changeCurrentStage"]),
    rowClass(item, type) {
      const colorClass = "bg-warning bg-lighten-5";
      if (!item || type !== "row") {
        return;
      }

      // eslint-disable-next-line consistent-return
      if (item.feedback_content) {
        return colorClass;
      }
    },
    async onAddFounder(payload) {
      await this.addFounder(payload).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckIcon",
            variant: "success",
          },
        });
        if(this.ngoInfo.current_stage == 1){
          if(this.founders && this.founders.length+1 === this.numberOfFounder ){
            this.changeCurrentStage(2)
          }
        }
        
      });
      console.log("this.founders.length plus one" , this.founders.length+1 )
      this.newBranchModal = false;
    },
      onClickedAddNumber(){
    //   if(this.founders && this.founders.length === this.numberOfFounder){
    //     this.isDisabled = true
    //   }
    //   else{

    //     this.newfounderModal = true
    //   }
      this.newfounderModal = true
    },
    onUpdateClicked(data) {
      console.log(data)
      let form = { id : data.id , full_name : data.full_name  , id_number : data.id_number  , address : data.address  , qualification_id  : data.qualification_id , job_title_id  : data.job_title_id , inquiry_bulletin_file : data.inquiry_bulletin_file  , phone_number : data.phone_number  , dob : data.dob  }
      this.updateFounderForm = JSON.parse(JSON.stringify(form));
      this.editFounderModal = true;
    },
    async onUpdateFounder(payload) {
      const toSave = resolveUpdated(payload, this.updateFounderForm);
      await this.updateFounder({ form: toSave, id: payload.id }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckIcon",
            variant: "success",
          },
        });
      });
      this.editBranchModal = false;
    },
    async onDeleteFounder(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف العضو ؟", {
          title: "تأكيد حذف عضو",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteFounder(id).then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "تمت العملية بنجاح",
                  icon: "CheckIcon",
                  variant: "success",
                },
              });
            });
        });
      this.editBranchModal = false;
    },
  },
};
</script>

<style lang="scss"></style>
